import React from 'react'
import { ReactComponent as CrossSvg } from '@sketch/icons/cross-circle-18'
import { ButtonUnstyled } from '../Button'
import styled, { css } from 'styled-components'

const StyledClearButton = styled(ButtonUnstyled)`
  width: 24px;
  height: 24px;
  margin: auto;

  display: flex;
  align-items: center;
  justify-content: center;
`

const CrossIcon = styled(CrossSvg).attrs({
  role: 'img',
  'aria-label': 'Clear',
})(
  () => css`
    width: 17px;
    height: 17px;

    cursor: pointer;
    color: ${({ theme }) => theme.colors.foreground.secondary.B};

    &:hover,
    &:focus {
      color: ${({ theme }) => theme.colors.foreground.secondary.A};
    }

    &:active {
      color: ${({ theme }) => theme.colors.foreground.secondary.B};
    }
  `
)

export interface ClearButtonProps {
  onClick: () => void
}

export const ClearButton: React.FC<ClearButtonProps> = ({ onClick }) => {
  return (
    <StyledClearButton
      aria-label="Clear search"
      type="button"
      onClick={onClick}
    >
      <CrossIcon />
    </StyledClearButton>
  )
}
